export const useBankDetails = () => {
  const internationalPayments = [
    {
      title: 'Beneficiary',
      value: 'Omnipresent Group Limited',
    },
    {
      title: 'Beneficiary address',
      value: '7 Bell Yard, WC2A 2JR, London, United Kingdom',
    },
    {
      title: 'Bank',
      value: 'Revolut Ltd.',
    },
    {
      title: 'IBAN',
      value: 'GB45 REVO 0099 6982 3799 92',
    },
    {
      title: 'BIC',
      value: 'REVOGB21',
    },
    {
      title: 'Intermediary BIC (GBP/USD)',
      value: 'CHASGB2L',
    },
    {
      title: 'Intermediary BIC (EUR)',
      value: 'CHASDEFX',
    },
    {
      title: 'Intermediary BIC (CAD/SEK)',
      value: 'BARCGB22',
    },
  ];

  const domesticGBPPayments = [
    {
      title: 'Beneficiary',
      value: 'Omnipresent Group Limited',
    },
    {
      title: 'Beneficiary address',
      value: '7 Bell Yard, WC2A 2JR, London, United Kingdom',
    },
    {
      title: 'Bank',
      value: 'Revolut Ltd.',
    },
    {
      title: 'Account number',
      value: '29909759',
    },
    {
      title: 'Sort code',
      value: '04-00-75',
    },
  ];

  const domesticUSDPayments = [
    {
      title: 'Beneficiary',
      value: 'Omnipresent Group Limited',
    },
    {
      title: 'Beneficiary address',
      value: '7 Bell Yard, WC2A 2JR, London, United Kingdom',
    },
    {
      title: 'Bank',
      value: 'Metropolitan Commercial Bank',
    },
    {
      title: 'Bank address',
      value: '99 Park Ave, NY, 10016, New York, United States',
    },
    {
      title: 'Account number',
      value: '253178658299',
    },
    {
      title: 'ACH routing number',
      value: '026014928',
    },
  ];
  return [internationalPayments, domesticGBPPayments, domesticUSDPayments];
};
